import { LOGIN_BUTTON, SEO_TITLE_LOGIN } from 'mk/autogenerated/translations/LoginPage.17e967995c692adc9018cda08ff8d047'
import { LOGIN_FORM_NAME, LoginFormData } from 'mk2/apps/users/components/LoginForm';
import styles from 'mk2/apps/users/components/LoginForm.mscss';
import Login from 'mk2/apps/users/containers/Login/Login';
import { loginTrigger } from 'mk2/apps/users/containers/Login/Login.actions';
import loginSaga from 'mk2/apps/users/containers/Login/Login.sagas';
import { SIGNUP_FORM_NAME } from 'mk2/apps/users/containers/Signup/Signup.constants';
import { loginSignupTabs } from 'mk2/apps/users/utils';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import { AppName } from 'mk2/containers/Application/Application';
import { cachedInitialValues, mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/helpers/form';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { AppState, getRequestDeviceMobile, getRequestLastKnownUsername } from 'mk2/reducers';
import { HeaderMenuItem, MenuSelection } from 'mk2/schemas';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}

interface StateProps extends FormPageStateProps {
    initialValues: LoginFormData;
    mobile: boolean;
}

interface DispatchProps extends FormPageDispatchProps {
    onLogin(values: LoginFormData);
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class LoginPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { location } = ownProps;

            const query = parse(location.search);
            const username = query.username
                ? query.username.toLowerCase()
                : getRequestLastKnownUsername(state);

            return {
                ...mkReduxFormMapStateToProps(LOGIN_FORM_NAME)(state),

                initialValues: cachedInitialValues(LOGIN_FORM_NAME, {
                    username: username || '',
                    password: '',
                }, username),
                mobile: getRequestDeviceMobile(state),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(SIGNUP_FORM_NAME),
            onLogin: loginTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_LOGIN;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <Login {...props} />
        );
    }

    public getHeaderRight(props: Props): React.ReactNode {
        return null;
    }

    public hasPageHeaderPart1(props: Props): boolean {
        const { mobile } = props;
        return mobile;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHeaderTabs(props: Props): (JSX.Element[] | null) {
        const { mobile } = props;
        if (mobile) {
            return loginSignupTabs('login');
        }
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: app,
            activeItem: HeaderMenuItem.UserLogin,
        };
    }

    public hasMobileLogo(): boolean {
        return true;
    }

    public getSubmitButton(props: Props): JSX.Element {
        return null;
    }

    public registerInStore(store: Store<AppState>) {
        // store.injectReducer('containers.users.login', loginReducer);
        store.injectSaga('containers.users.login', loginSaga);
    }
}
